module.exports = __webpack_public_path__ + "img/treeplant5_7-8-2021.8a315628.jpg";